export default "__VITE_ASSET__BBkZEraK__"